import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import type { TransformationsCssFeature } from './transformations.types'
import { transformationsVariants } from './transformationsVariantsCompNode'
import { transformations } from './transformationsCompNode'
import { transformationsDomApplier } from './transformationsDomApplier'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'

export const transformationsCssFeature: TransformationsCssFeature = {
	featureName: 'transformations',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { transformationsVariants, transformations },
	intermediateNodes: {},
	dataMaps: ['variants_data', 'transformations_data'],
	domApplier: transformationsDomApplier,
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(transformationsCssFeature)
}
export const editor: BindFeature = page
